<template>
	<button :class="detectClass" class="btn">
		<slot>Button</slot>
	</button>
</template>

<script>
	export default {
		name: 'InputButton',
		data() {
			return {
				detectClass: {
					'btn-primary': this.btnClass === 'btn-primary',
					'btn-grey': this.btnClass === 'btn-grey',
					'btn-red': this.btnClass === 'btn-red'
				}
			}
		},
		props: ['btnClass']
	}
</script>

<style lang="scss" scoped>
	button {
		border: 0;
		padding: 9px 20px;
		border-radius: 25px;
		outline: none;
		cursor:pointer;

		&.btn-primary
		{
			background-color: #38b7ea;
			color: #fff;
		}

		&.btn-grey {
			background-color: #ececec;
			border: 1px solid #d4d4d4;
		}

		&.btn-red {
			background-color: #ececec;
			color: #d43131;
			border: 1px solid #d4d4d4;
		}

		svg {
			margin-left: 7px;

			@media only screen and (max-width: 800px) {
				display:none;
			}
		}
	}
</style>
